/** Định dạng số tiền VND kiểu "50.000". */
export function formatAmount(value: number): string {
  return new Intl.NumberFormat("vi-VN").format(value);
}

/** Bỏ mọi ký tự không phải chữ số khỏi chuỗi nhập số tiền. */
export function parseAmountInput(raw: string): number | undefined {
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 0) return undefined;
  const n = Number(digits);
  return Number.isFinite(n) ? n : undefined;
}

/** Tách nhóm số tài khoản để dễ đọc, ví dụ "0123 4567 89". Giá trị gửi đi vẫn không có khoảng trắng. */
export function formatAccountNumberDisplay(raw: string): string {
  const digits = raw.replace(/\s/g, "");
  return digits.replace(/(.{4})/g, "$1 ").trim();
}

export function stripSpaces(raw: string): string {
  return raw.replace(/\s/g, "");
}
